import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { FaSpinner } from "react-icons/fa6";
import { BsBuilding } from "react-icons/bs"; // Company
import { IoMdTrendingUp, IoMdTrendingDown } from "react-icons/io";
import axios from "axios";
import {
  FaRupeeSign,
  FaArrowUp,
  FaArrowDown,
  FaChartLine,
  FaChartBar,
  FaProjectDiagram,
} from "react-icons/fa";

// const SearchGlobal = () => {
//   const { ticker } = useParams();
//   const [stock, setStock] = useState();
//   const [detail, setDetail] = useState();
//   const [results, setResults] = useState([]);

//   const [rsi, setRsi] = useState();
//   const [loading, setLoading] = useState(false);

//   const CACHE_TTL = 60 * 60 * 1000; // 1 hour
//   const cacheKey = `stock_${ticker.toUpperCase()}_cache`;

//   const handleRefresh = async (forceRefresh = false) => {
//     if (!ticker) return;

//     try {
//       setLoading(true);

//       // 🧩 1️⃣ Try cached data (if not forced)
//       const cached = JSON.parse(localStorage.getItem(cacheKey));
//       const isValid =
//         cached && Date.now() - cached.timestamp < CACHE_TTL && cached.data;

//       if (isValid && !forceRefresh) {
//         console.log(`✅ Using cached data for ${ticker}`);
//         setStock(cached.data.overview);
//         setDetail(cached.data.daily);
//         setRsi(cached.data.rsi);
//         setLoading(false);
//         return;
//       }

//       console.log(`🆕 Fetching new data for ${ticker}...`);

//       // 🧩 2️⃣ Fetch fresh data
//       const [overviewRes, dailyRes, rsiRes] = await Promise.all([
//         axios.get("http://localhost:8000/api/stockoverview", {
//           params: { symbol: ticker },
//         }),
//         axios.get("http://localhost:8000/api/stockdailydata", {
//           params: { symbol: ticker },
//         }),
//         axios.get("http://localhost:8000/api/stockRsi", {
//           params: { symbol: ticker },
//         }),
//       ]);

//       const newData = {
//         overview: overviewRes.data,
//         daily: dailyRes.data,
//         rsi: rsiRes.data,
//       };

//       // 🧩 3️⃣ Update state
//       setStock(newData.overview);
//       setDetail(newData.daily);
//       setRsi(newData.rsi);

//       // 🧩 4️⃣ Save to localStorage
//       localStorage.setItem(
//         cacheKey,
//         JSON.stringify({
//           timestamp: Date.now(),
//           data: newData,
//         })
//       );

//       console.log(`💾 Cached fresh data for ${ticker}`);
//     } catch (err) {
//       console.error(`❌ Error fetching data for ${ticker}:`, err.message);
//     } finally {
//       setLoading(false);
//     }
//   };
//   console.log("Response", stock);
//   console.log("Detail", detail);
//   console.log("Rsi", rsi);
//   const rsiData = rsi?.["Technical Analysis: RSI"];
//   const dates = rsiData && Object.keys(rsiData);

//   dates?.sort((a, b) => new Date(a) - new Date(b));

//   const latestDate = dates?.[dates.length - 1];
//   console.log("Latest date", latestDate);

//   const latestRSI = parseFloat(rsiData?.[latestDate]?.RSI || 0);
//   console.log("LatestRsi", latestRSI);
//   //   const timeDetail = detail["Time Series (Daily)"];
//   //   console.log("TimeDetail", timeDetail);
//   //   const latestDate = Object.keys(timeDetail).sort(
//   //     (a, b) => new Date(b) - new Date(a)
//   //   )[0];

//   //   const latestData = timeDetail[latestDate];
//   //   console.log("detail", latestData);
//   useEffect(() => {
//     handleRefresh();
//   }, [ticker]);

//   let latestStockData = null;

//   const timeSeries = detail?.["Time Series (Daily)"];

//   if (timeSeries && typeof timeSeries === "object") {
//     const dates = Object.keys(timeSeries).sort(
//       (a, b) => new Date(b) - new Date(a)
//     );
//     const latestDate = dates[0];
//     latestStockData = { date: latestDate, ...timeSeries[latestDate] };
//   }

//   let percentChange = null;
//   if (timeSeries) {
//     const dates = Object.keys(timeSeries).sort(
//       (a, b) => new Date(b) - new Date(a)
//     );

//     const latestDate = dates[0];
//     const prevDate = dates[1];

//     const latestClose = parseFloat(timeSeries[latestDate]["4. close"]);
//     const prevClose = parseFloat(timeSeries[prevDate]["4. close"]);

//     percentChange = (((latestClose - prevClose) / prevClose) * 100).toFixed(2);
//   }
//   console.log("Percent Change", percentChange);

//   console.log("Latest Stock Data:", latestStockData);

//   const companyName = stock?.Name;
//   console.log("companyName", companyName);
//   const symbolCode = stock?.Symbol;
//   console.log("Symbol", symbolCode);
//   const peRatio = stock?.PERatio;
//   console.log("PE Ratio", peRatio);
//   const bookValue = stock?.BookValue;
//   console.log("bookValye", bookValue);
//   const low = latestStockData?.["3. low"];
//   console.log("Low", low);
//   const high = latestStockData?.["2. high"];
//   console.log("High", high);
//   const open = latestStockData?.["1. open"];
//   console.log("Open", open);
//   const close = latestStockData?.["4. close"];
//   console.log("Close", close);
//   const volume = latestStockData?.["5. volume"];

//   return (
//     <div>
//       <>
//         <div className="stock-cards-container">
//           {stock ? (
//             <>
//               <div className="stock-extra-card company-card">
//                 <div className="company-left">
//                   <BsBuilding className="card-icon" />
//                   <div className="company-text">
//                     <p className="card-label">Company</p>
//                     <p className="card-value">{companyName}</p>
//                   </div>
//                 </div>
//                 <div className="company-left">
//                   <BsBuilding className="card-icon" />
//                   <div className="company-text">
//                     <p className="card-label">SYMBOL</p>
//                     <p className="card-value">{symbolCode}</p>
//                   </div>
//                 </div>

//                 {/* <div className="company-right">
//                               <p
//                                 className="result-value

//                               "
//                                 style={{ color: timeFrame === "min" ? color1 : color }}
//                               >
//                                 {timeFrame === "min" ? result1 : result}
//                               </p>
//                             </div> */}
//               </div>

//               {/* Other Cards in Grid */}
//               <div className="extra-cards-grid">
//                 {/* <div className="stock-extra-card">
//                               <div className="card-left">

//                                 <p className="card-label">LTP</p>
//                               </div>
//                               <div className="card-right">
//                                 <p className="card-value">₹{stock.ltp}</p>
//                               </div>
//                             </div> */}

//                 {/* Open */}
//                 <div className="stock-extra-card">
//                   <div className="card-left">
//                     <p className="card-label">RSI</p>
//                   </div>
//                   <div
//                     className="card-right"
//                     style={{ display: "flex", gap: "1rem" }}
//                   >
//                     {latestRSI?.toFixed(2) > 0 ? (
//                       <IoMdTrendingUp className="card-icon" color="#2fd18a" />
//                     ) : (
//                       <IoMdTrendingDown className="card-icon" color="#f87171" />
//                     )}
//                     <p
//                       className="card-value"
//                       style={{
//                         color: latestRSI > 0 ? "#2fd18a" : "#f87171",
//                       }}
//                     >
//                       {latestRSI?.toFixed(2)}
//                     </p>
//                   </div>
//                 </div>
//                 <div className="stock-extra-card">
//                   <div className="card-left">
//                     <p className="card-label">Open</p>
//                   </div>
//                   <div className="card-right">
//                     <p className="card-value">{open}</p>
//                   </div>
//                 </div>

//                 {/* % Change */}
//                 <div className="stock-extra-card">
//                   <div className="card-left">
//                     <p className="card-label">Low</p>
//                   </div>
//                   <div className="card-right">
//                     <p className="card-value">{low}</p>
//                   </div>
//                 </div>

//                 <div
//                   className={`stock-extra-card ${
//                     percentChange >= 0 ? "positive" : "negative"
//                   }`}
//                 >
//                   <div className="card-left">
//                     <p className="card-label">% Change</p>
//                   </div>
//                   <div
//                     className="card-right"
//                     style={{ display: "flex", gap: "1rem" }}
//                   >
//                     {percentChange > 0 ? (
//                       <IoMdTrendingUp className="card-icon" color="#2fd18a" />
//                     ) : (
//                       <IoMdTrendingDown className="card-icon" color="#f87171" />
//                     )}
//                     <p className="card-value">{percentChange}%</p>
//                   </div>
//                 </div>

//                 {/* <div className="stock-extra-card">
//                               <div className="card-left">

//                                 <p className="card-label">MACD</p>
//                               </div>
//                               <div
//                                 className="card-right"
//                                 style={{ display: "flex", gap: "1rem" }}
//                               >
//                                 {latestMACD?.MACD > 0 ? (
//                                   <IoMdTrendingUp className="card-icon" color="#2fd18a" />
//                                 ) : (
//                                   <IoMdTrendingDown
//                                     className="card-icon"
//                                     color="#f87171"
//                                   />
//                                 )}
//                                 <p
//                                   className="card-value"
//                                   style={{
//                                     color: latestMACD?.MACD > 0 ? "#2fd18a" : "#f87171",
//                                   }}
//                                 >
//                                   {latestMACD?.MACD?.toFixed(2)}
//                                 </p>
//                               </div>
//                             </div>
//            */}

//                 <div className="stock-extra-card">
//                   <div className="card-left">
//                     <p className="card-label">Close</p>
//                   </div>
//                   <div className="card-right">
//                     <p className="card-value">{close}</p>
//                   </div>
//                 </div>

//                 <div className="stock-extra-card">
//                   <div className="card-left">
//                     <p className="card-label">High</p>
//                   </div>
//                   <div className="card-right">
//                     <p className="card-value">{high}</p>
//                   </div>
//                 </div>

//                 <div className="stock-extra-card">
//                   <div className="card-left">
//                     <p className="card-label">Volume</p>
//                   </div>
//                   <div className="card-right">
//                     <p className="card-value">{volume}</p>
//                   </div>
//                 </div>

//                 {/* {peRatio && (
//                               <div className="stock-extra-card">
//                                 <div className="card-left">

//                                   <p className="card-label">PE Ratio</p>
//                                 </div>
//                                 <div className="card-right">
//                                   <p className="card-value">{peRatio}</p>
//                                 </div>
//                               </div>
//                             )} */}
//                 {/* {faceValue && (
//                               <div className="stock-extra-card">
//                                 <div className="card-left">

//                                   <p className="card-label">Face Value</p>
//                                 </div>
//                                 <div className="card-right">
//                                   <p className="card-value">{faceValue}</p>
//                                 </div>
//                               </div>
//                             )} */}
//                 <div
//                   className="stock-extra-card"
//                   style={{ backgroundColor: "#2fd18a", color: "white" }}
//                 >
//                   <button
//                     className="view-more-btn-stock"
//                     style={{
//                       width: "100%",
//                       fontSize: "1.2rem",
//                       fontWeight: "700",
//                       color: "white",
//                       background: "inherit",
//                       border: "none",
//                     }}
//                   >
//                     Add to Watchlist
//                   </button>
//                 </div>
//               </div>
//             </>
//           ) : (
//             <p
//               style={{
//                 fontSize: "1rem",
//                 fontWeight: "700",
//                 color: "white",
//                 display: "flex",
//                 gap: "1rem",
//               }}
//             >
//               Fetching Live data..{" "}
//               <span style={{ paddingLeft: "10px", marginTop: "5px" }}>
//                 <FaSpinner />
//               </span>
//             </p>
//           )}
//         </div>
//       </>
//     </div>
//   );
// };

// export default SearchGlobal;
const SearchGlobal = () => {
  const { searchText } = useParams();
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const BASE_URL = process.env.REACT_APP_API_BASE_URL;

  useEffect(() => {
    const fetchResults = async () => {
      if (!searchText) return;
      setLoading(true);
      try {
        const response = await axios.get(`${BASE_URL}/api/stockName`, {
          params: {
            keywords: searchText.trim(),
          },
        });

        const matches = response.data.bestMatches || [];
        setResults(matches);
      } catch (err) {
        console.error("Error fetching results:", err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchResults();
  }, [searchText]);
  const handleClick = (symbol) => {
    navigate(`/globalstock/${symbol}`); // this triggers your detailed page
  };
  
  return (
    <div style={{ maxWidth: "600px", margin: "2rem auto", padding: "1rem" }}>
      {loading ? (
        <p
          style={{
            fontSize: "1rem",
            fontWeight: "700",
            color: "white",
            display: "flex",
            gap: "1rem",
          }}
        >
          Fetching Live data..{" "}
          <span style={{ paddingLeft: "10px", marginTop: "5px" }}>
            <FaSpinner />
          </span>
        </p>
      ) : results.length > 0 ? (
        results.map((item, idx) => (
          <div
            key={idx}
            onClick={() => handleClick(item["1. symbol"])}
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              //   padding: "12px 15px",
              //   border: "1px solid #ddd",

              marginBottom: "8px",
              cursor: "pointer",
              //   background: "#fafafa",
              transition: "0.2s",
              padding: "12px 16px",
              background: "#0f1720",
              borderRadius: "8px",
              boxShadow: "0 2px 6px rgba(0, 0, 0, 0.2)",
            }}
            // onMouseEnter={(e) =>
            //   (e.currentTarget.style.backgroundColor = "#e8f0ff")
            // }
            // onMouseLeave={(e) =>
            //   (e.currentTarget.style.backgroundColor = "#fafafa")
            // }
          >
            <div>
              <strong
                style={{ fontSize: "14px", color: "white", fontWeight: "700" }}
              >
                {item["1. symbol"]}
              </strong>
              <div
                style={{ fontSize: "14px", color: "white", fontWeight: "700" }}
              >
                {item["2. name"]}
              </div>
            </div>
            <span
              style={{ fontSize: "14px", color: "white", fontWeight: "700" }}
            >
              {item["4. region"]}
            </span>
          </div>
        ))
      ) : (
        <p
          style={{
            fontSize: "1rem",
            fontWeight: "700",
            color: "white",
            display: "flex",
            gap: "1rem",
          }}
        >
          No results found.
        </p>
      )}
    </div>
  );
};
export default SearchGlobal;
